/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GameEvents,
  GameEventsParams,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Game events list
 */
export const gameEvents = (
    params?: MaybeRefOrGetter<GameEventsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<GameEvents>(
      {url: `/game-events`, method: 'GET',
        params, signal
    },
      );
    }




export const getGameEventsQueryKey = (params?: MaybeRefOrGetter<GameEventsParams>,) => {
    return [
    'game-events', ...(params ? [params] : [])
    ] as const;
    }


export const getGameEventsQueryOptions = <TData = Awaited<ReturnType<typeof gameEvents>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GameEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameEvents>>> = ({ signal }) => gameEvents(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameEvents>>, TError, TData>
}

export type GameEventsQueryResult = NonNullable<Awaited<ReturnType<typeof gameEvents>>>
export type GameEventsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Game events list
 */

export function useGameEvents<TData = Awaited<ReturnType<typeof gameEvents>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GameEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






